// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo__-NHQs","highlighted":"MainLogo_highlighted__10HtY"};